export enum AddOnEntitlements {
  AddOnBundle = "addon_bundle",
  FilmmakersSync = "filmmakers_sync",
}
